import { forwardRef } from 'react';
import '../assets/css/AboutUs.css';

const AboutUs = forwardRef<HTMLElement, {}>((props, ref) => {
    return (
        <section className="all-main-section" ref={ref}>
            <div className="all-main-section-overlay"></div>
            <div className="all-main-section-content-wrapper">
                <h2 className="all-main-title" style={{ textAlign: "center" }}>
                    <span>About</span> Us
                </h2>

                <p className="about-us-description">
                    At <strong>HEM</strong>, we are dedicated to connecting you with the finest local restaurants and grocery stores in your community. Our platform is designed to make your life simpler and more delicious by offering a wide variety of fresh foods, everyday essentials, and specialty items all in one convenient place.
                </p>
                <p className="about-us-description">
                    Whether you're planning a family dinner, need quick groceries, or want to explore new culinary delights, we have you covered. We carefully select and partner with trusted vendors who share our commitment to quality and sustainability. Every order is handled with care and delivered promptly to ensure maximum freshness and satisfaction.
                </p>
                <p className="about-us-description">
                    Our mission goes beyond just delivery — we aim to empower local businesses and promote healthy, sustainable eating habits. With user-friendly features, personalized recommendations, and round-the-clock support, <strong>HEM</strong> is your go-to destination for convenient, reliable, and delicious food delivery. Join us in celebrating the tastes of your neighborhood, and let us bring the best of the community right to your doorstep.
                </p>

                <div className="about-us-highlights">
                    <div className="highlight-box">
                        <i className="fas fa-leaf highlight-icon"></i>
                        <h3>Fresh & Local</h3>
                        <p>We partner with local vendors to ensure the freshest meals and groceries.</p>
                    </div>
                    <div className="highlight-box">
                        <i className="fas fa-shipping-fast highlight-icon"></i>
                        <h3>Fast Delivery</h3>
                        <p>Get your orders delivered quickly and on time every time.</p>
                    </div>
                    <div className="highlight-box">
                        <i className="fas fa-shopping-cart highlight-icon"></i>
                        <h3>Easy Ordering</h3>
                        <p>A user-friendly platform to make ordering effortless and enjoyable.</p>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default AboutUs;
